/**
 * @author José Rafael Gutierrez
 * @param arrayNewLivePlay
 * @param objectNewLivePlayIndexes
 * @param mapCategories
 * @param isReceived
 * @returns {*[]}
 */
export function playStructure(arrayNewLivePlay, objectNewLivePlayIndexes, mapCategories /*, isReceived = false*/) {
  const arrayGeneralCategoriesIds = mapCategories.get(arrayNewLivePlay[objectNewLivePlayIndexes.categoryId]);

  return [
    arrayGeneralCategoriesIds || [],
    arrayNewLivePlay[objectNewLivePlayIndexes.teamId],
    arrayNewLivePlay[objectNewLivePlayIndexes.matchResult],
    arrayNewLivePlay[objectNewLivePlayIndexes.playingAs],
    arrayNewLivePlay[objectNewLivePlayIndexes.matchLapse],
    arrayNewLivePlay[objectNewLivePlayIndexes.section],
    arrayNewLivePlay[objectNewLivePlayIndexes.total],
  ];
}
